var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgMail = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" }, props, { children: _jsx("path", { fill: "currentColor", d: "M7.218 10.924a13.465 13.465 0 0 0 5.858 5.858l1.955-1.955c.24-.24.596-.32.907-.214.995.33 2.07.507 3.173.507.489 0 .889.4.889.889v3.102c0 .489-.4.889-.889.889C10.764 20 4 13.236 4 4.889 4 4.4 4.4 4 4.889 4H8c.489 0 .889.4.889.889 0 1.111.178 2.178.507 3.173a.892.892 0 0 1-.223.907l-1.955 1.955Z" }) }))); };
export default SvgMail;
